import {Component, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {Util} from '../../../../../app/util';
import {CONFIG} from "../../../../../app/config";
import {WebsiteSpotPage} from "../../website-spot";

@Component({
    selector: 'cp-button',
    templateUrl: 'cp-button.html'
})

export class CpButton {

    config: any;
    buttun: any;

    @Input('hpage')     public hpage: WebsiteSpotPage;
    @Input('blocked')   public blocked: any;
    @Input('display')   public display: 'block' | 'inline' = 'block';

    @Output('cp-click') private _click: EventEmitter<any> = new EventEmitter();

    constructor(private element: ElementRef, public util: Util, private renderer: Renderer2) {

        this.config = CONFIG;

    }

    ngOnInit() {

        this.buttun = this.blocked.Button;

        setTimeout(() => {

            if (this.element.nativeElement.children[0].children[1] && this.element.nativeElement.children[0].children[1].innerHTML.trim()) {
                this.element.nativeElement.children[0].children[0].children[0].innerHTML = this.element.nativeElement.children[0].children[1].innerHTML;
            }

            if (this.element.nativeElement.className) {
                this.element.nativeElement.className.split(' ').forEach(name => this.renderer.addClass(this.element.nativeElement.children[0].children[0], name));
                this.element.nativeElement.className = '';
            }

            if (this.element.nativeElement.children[0].children[0].className.indexOf('button-outline') !== -1) {
                this.renderer.setStyle(this.element.nativeElement.children[0].children[0].children[0], 'color', this.hpage.config.colors[this.blocked.Button.Cortwo]);
            }

            if (this.display == 'block') {
                this.renderer.addClass(this.element.nativeElement, 'display-block');
                this.renderer.addClass(this.element.nativeElement, 'margin-auto-x');
                this.renderer.setStyle(this.element.nativeElement, 'max-width', '500px');
            }

        });

    }

    _emitClick(event) {

        this._click.emit(event);

    }

    buttonTextod(): string {

        return this.hpage.platenode(this.blocked, 'Button', 'Textod');

    }

    buttunCorone(): string {

        return this.hpage.platenode(this.blocked, 'Button', 'Corone');

    }

    buttunFill(): string {

        return this.hpage.platenode(this.blocked, 'Button', 'Fill');

    }

    buttunSize(): string {

        return this.hpage.platenode(this.blocked, 'Button', 'Size');

    }

    buttunShape(): string {

        return this.hpage.platenode(this.blocked, 'Button', 'Shape');

    }

    buttunStyle(buttun, isOutline = false): any {

        let filled = this.hpage.platenode(this.blocked, 'Button', 'Fill');
        let cliped = this.hpage.platenode(this.blocked, 'Button', 'Clip');
        let corone = this.hpage.platenode(this.blocked, 'Button', 'Corone');
        let cortwo = this.hpage.platenode(this.blocked, 'Button', 'Cortwo');
        let fonted = this.hpage.platenode(this.blocked, 'Button', 'Fonted');
        let weight = this.hpage.platenode(this.blocked, 'Button', 'Weight');
        let border = (weight >= 600 ? '2px solid' : null);

        let object: any = {};

        if (!isOutline) {

            let colorx = this.config.negative(corone);

            let backg = 'linear-gradient(to bottom, ' + this.config.colors[corone] + ', ' + this.config.colors[cortwo] + ')';
            if (filled != 'Solid') backg = '';

            object = {color: colorx, 'background': backg};

        }

        object = {'font-family': fonted, 'font-weight': weight, border: border, ...object};

        if (cliped) {
            //Exemple: cliped = 'TL,TR,BR,BL';
            const clipArray = cliped.split(',');
            const tl = clipArray.indexOf('TL') >= 0 ? '20%' : '0';
            const tr = clipArray.indexOf('TR') >= 0 ? '80%' : '100%';
            const br = clipArray.indexOf('BR') >= 0 ? '80%' : '100%';
            const bl = clipArray.indexOf('BL') >= 0 ? '20%' : '0';

            const outL = filled == 'Solid' ? '50%' : '100%';
            const outR = filled == 'Solid' ? '50%' : '0';

            // 6 = 100, ult = 0
            object = {'clip-path': 'polygon(' + tl + ' 0, ' + tr + ' 0, 99% ' + outR + ', ' + br + ' 100%, ' + bl + ' 100%, 1% ' + outL + ')', ...object};
            //                                  20%    0,     80%    0, 100%     50%,         80%    100%,     20%    100%, 0        50%
        }

        return object;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-button/cp-button.ts